export * from './post-vermerk.service';
export * from './post-vermerk.service.module';